import React, { Fragment, useEffect, useRef, useState } from 'react';
import { translate } from '../../Services/translation';

const ProductResults = ({ filteredProducts, selectedItem }) => {
  return (
    <ul className="quick-search-result__products-wrapper quick-search-result__item-wrapper">
      {filteredProducts &&
        filteredProducts.map((item, index) => (
          <Fragment key={`${item.name}-${index}`}>
            <li
              key={item.url}
              className={`quick-search-result__item ${
                selectedItem === index
                  ? 'quick-search-result__item--selected'
                  : ''
              }`}
            >
              <a
                className={
                  item.showAll
                    ? 'quick-search-result__show-all'
                    : `quick-search-result__link ${
                        item.url ? '' : 'quick-search-result__link--disabled'
                      }`
                }
                href={item.showAll ? searchUrl : item.url}
              >
                {item.hasImage && item.imageSource && (
                  <div className="quick-search-result__image--wrapper">
                    <img
                      alt={item.name}
                      className="quick-search-result__image"
                      src={item.imageSource}
                    />
                  </div>
                )}
                <div className="quick-search-result__item--title">
                  {item.name}
                  <span className="text-small color-grey-500 lh-1">
                    {item.category}
                  </span>
                  <div className="color-grey-900 text-large lh-1 bold">
                    {item.lowestPrice
                      ? `${translate('quicksearch.price.lowestprice')} ${
                          item.lowestPrice
                        }`
                      : null}
                  </div>
                </div>
              </a>
            </li>
          </Fragment>
        ))}
    </ul>
  );
};

export default ProductResults;
